import React                            from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import Gallery                          from '../../components/Gallery/Gallery';
import PjaxWrapper                      from '../../utils/PjaxWrapper';

const onReady = function(guestIsLoggedIn, initialVideos) {
	// Gallery
	const renderGallery = function() {
		const galleryContainer = document.getElementById('tv-mediathek--teaser__gallery-container');

		if (galleryContainer) {
			render(
				<Gallery initialVideos={initialVideos}
				         isModelGuestFavorite={false}
				         onShowModal={null}
				/>,
				galleryContainer
			);

			PjaxWrapper.addUnloadFunc(function(node) {
				unmountComponentAtNode(node);
			}.bind(this, galleryContainer));
		}
	};
	renderGallery();
};

function run(
	guestIsLoggedIn,
	initialVideos
) {
	const _onReady = onReady.bind(this, guestIsLoggedIn, initialVideos);

	if (document.readyState !== 'loading') {
		_onReady();
	} else {
		window.addEventListener('DOMContentLoaded', _onReady);
	}
}

export {run};
